import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const LockIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 18 20"
      sx={{ '&.MuiSvgIcon-root': { width: '18px', height: '18px' }, fill: 'transparent', ...sx }}
      {...props}
    >
      {props.type === 'unlocked' ? (
        <path
          d="M5.25 8.25V6C5.25 3.92893 6.92893 2.25 9 2.25C10.8142 2.25 12.3275 3.53832 12.675 5.25M6.6 15.75H11.4C12.6601 15.75 13.2902 15.75 13.7715 15.5048C14.1948 15.289 14.539 14.9448 14.7548 14.5215C15 14.0402 15 13.4101 15 12.15V11.85C15 10.5899 15 9.95982 14.7548 9.47852C14.539 9.05516 14.1948 8.71095 13.7715 8.49524C13.2902 8.25 12.6601 8.25 11.4 8.25H6.6C5.33988 8.25 4.70982 8.25 4.22852 8.49524C3.80516 8.71095 3.46095 9.05516 3.24524 9.47852C3 9.95982 3 10.5899 3 11.85V12.15C3 13.4101 3 14.0402 3.24524 14.5215C3.46095 14.9448 3.80516 15.289 4.22852 15.5048C4.70982 15.75 5.33988 15.75 6.6 15.75Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <path
          d="M15.5832 9.66667V7.83333C15.5832 5.30203 13.5311 3.25 10.9998 3.25C8.46853 3.25 6.4165 5.30203 6.4165 7.83333V9.66667M10.9998 13.7917V15.625M8.0665 19.75H13.9332C15.4733 19.75 16.2434 19.75 16.8316 19.4503C17.3491 19.1866 17.7698 18.7659 18.0334 18.2485C18.3332 17.6602 18.3332 16.8901 18.3332 15.35V14.0667C18.3332 12.5265 18.3332 11.7564 18.0334 11.1682C17.7698 10.6507 17.3491 10.2301 16.8316 9.9664C16.2434 9.66667 15.4733 9.66667 13.9332 9.66667H8.0665C6.52636 9.66667 5.75629 9.66667 5.16803 9.9664C4.65058 10.2301 4.22989 10.6507 3.96624 11.1682C3.6665 11.7564 3.6665 12.5265 3.6665 14.0667V15.35C3.6665 16.8901 3.6665 17.6602 3.96624 18.2485C4.22989 18.7659 4.65058 19.1866 5.16803 19.4503C5.75629 19.75 6.52636 19.75 8.0665 19.75Z"
          stroke={props.color === 'secondary' ? '#FFFFFF' : props.color === 'primary' ? '#000000' : '#FF5F57'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </SvgIcon>
  );
};

export default LockIcon;
